export enum EyeColorEnum {
  BLUE = "Azuis",
  BROWN = "Castanhos",
  HETEROCHROMIA = "Heterocromia",
  BLACK = "Pretos",
  GREEN = "Verdes",
  OTHER = "Outros",
}

export type EyeColorKey = keyof typeof EyeColorEnum;

export enum HairColorEnum {
  BROWN = "Castanho",
  LIGHT_BROWN = "Castanho Claro",
  GRAY = "Grisalho",
  BLOND = "Loiro",
  BLACK = "Preto",
  REDHEAD = "Ruivo",
}

export type HairColorKey = keyof typeof HairColorEnum;

export enum CurrentHairColorEnum {
  BROWN = "Castanho",
  LIGHT_BROWN = "Castanho Claro",
  GRAY = "Grisalho",
  BLOND = "Loiro",
  BLACK = "Preto",
  REDHEAD = "Ruivo",
  DYED = "Colorido",
}

export type CurrentHairColorKey = keyof typeof CurrentHairColorEnum;

export enum HairTypeEnum {
  STRAIGHT = "Liso",
  KINKY = "Crespo",
  WAVY = "Ondulado",
  CURLY = "Cacheado",
  OTHER = "Outro",
}

export type HairTypeKey = keyof typeof HairTypeEnum;

export enum CurrentHairTypeEnum {
  STRAIGHT = "Liso",
  KINKY = "Crespo",
  WAVY = "Ondulado",
  CURLY = "Cacheado",
  DREADLOCK = "Dreadlock",
  OTHER = "Outro",
}

export type CurrentHairTypeKey = keyof typeof CurrentHairTypeEnum;

export enum SkinColorEnum {
  YELLOW = "Amarelo",
  WHITE = "Branca",
  INDIGENOUS = "Indígena",
  BROWN = "Parda",
  BLACK = "Preta",
}

export type SkinColorKey = keyof typeof SkinColorEnum;

export enum PhysicalCharacteristicEnum {
  VITILIGO = "Vitiligo",
  ALBINO = "Albino",
  PLUS_SIZE = "Plus size",
  CURVES = "Curves",
  OTHERS = "Outros",
}

export type PhysicalCharacteristicKey = keyof typeof PhysicalCharacteristicEnum;
